import React, { useState, useEffect } from "react";
import Form, {
  SimpleItem,
  GroupItem,
  TabbedItem,
  ButtonItem,
  Label,
  Tab,
  RequiredRule,
} from "devextreme-react/form";
import FileSelectPopup from "../../components/file/FileSelectPopup";
import { loadMessages, formatMessage, locale } from "devextreme/localization";
import dictionary from "../../data/dictionary";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import notify from "devextreme/ui/notify";
import Toolbar, { Item } from "devextreme-react/toolbar";
import { useHistory, useParams } from "react-router-dom";
import useJSON from "../../hook/useJSON";
import HardContentItemsList from "../../components/website/HardContentItemsList";
import { WEBSITE_URL } from "../../utils/constants";
import useWindowDimensions from "../../hook/useWindowDimensions";
import CKHtmlEditor from "../../components/html/CKHtmlEditor";

loadMessages(dictionary);
// const notesEditorOptions = { height: 150 };

const tabsMock = [
  {
    id: 0,
    text: "vi-VN",
    icon: "globe",
    content: "Vietnamese",
  },
];

const HardContentVM = (data, languages) => {
  const returnData = useJSON(data, languages);
  return returnData;
};

const HardContentMV = (data, languages) => {
  const nameObj = {};
  const descriptionObj = {};
  languages.forEach((language) => {
    nameObj[[language.languageId]] = data[`name-${language.languageId}`];
    descriptionObj[[language.languageId]] =
      data[`description-${language.languageId}`];
  });

  return JSON.stringify({
    name: JSON.stringify(nameObj),
    code: data.code,
    description: JSON.stringify(descriptionObj),
    url: data.url,
    image: data.image,
    alt: data.alt,
    order: data.order,
    isActive: data.isActive,
    concurrencyStamp: data.concurrencyStamp,
  });
};

const HardContentDetailContainer = ({
  accessToken,
  websiteLanguages,
  currentLanguage,
  currentWebsite,
}) => {
  locale(currentLanguage.substring(0, 2));
  const [tabs, setTabs] = useState(tabsMock);
  const [hardContent, setHardContent] = useState({});
  const history = useHistory();
  const params = useParams();
  const URL = `${WEBSITE_URL}HardContents/${currentWebsite}`;
  const { height } = useWindowDimensions();
  const [editor, setEditor] = useState(null);

  useEffect(() => {
    if (!params.hardContentId) return;

    fetch(
      `${WEBSITE_URL}HardContents/${currentWebsite}/${params.hardContentId}`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Access-Control-Allow-Origin": "*",
        },
      }
    ).then((result) =>
      result
        .json()
        .then((json) => {
          if (result.ok) {
            setHardContent(HardContentVM(json.data, websiteLanguages));
            return;
          }
          throw json.Message;
        })
        .catch(() => {
          if (result.status === 401) {
            history.push("/login");
          }
        })
    );
  }, [
    params.hardContentId,
    websiteLanguages,
    history,
    accessToken,
    currentWebsite,
  ]);

  const updateImage = (e) => {
    setHardContent((prevState) => ({ ...prevState, image: e }));
  };

  useEffect(() => {
    const _tabs = websiteLanguages.map((item, index) => ({
      id: index,
      languageId: item.languageId,
      text: item.name,
      icon: "globe",
      content: "User tab content",
    }));
    setTabs(_tabs);
  }, [websiteLanguages]);

  const handleSubmit = (e) => {
    e.preventDefault();
    updateHardContent();
  };

  const updateHardContent = () => {
    const _method = hardContent.id ? "PUT" : "POST";
    const _url = `${URL}${hardContent.id ? `/${hardContent.id}` : ""}`;

    const editorData = editor?.getData();
    const _hardContent = Object.assign({}, hardContent);

    websiteLanguages.forEach((language) => {
      _hardContent[`description-${language.languageId}`] = editorData;
    });

    return fetch(_url, {
      method: _method,
      body: HardContentMV(_hardContent, websiteLanguages),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
        "Accept-Language": currentLanguage,
      },
    }).then((result) => {
      if (result.ok) {
        return result.text().then((text) => {
          notify(
            {
              message: JSON.parse(text).message,
              position: {
                my: "center top",
                at: "center top",
              },
            },
            "success",
            3000
          );
          history.push("/info-website");
          history.push({
            pathname: "/info-website",
            state: { activeTab: 3 },
          });
        });
      } else {
        return result.json().then((json) => {
          throw json.Message;
        });
      }
    });
  };

  const backButtonOptions = {
    type: "back",
    onClick: () => {
      history.goBack();
    },
  };

  const saveButtonOptions = {
    text: "Update",
    type: "success",
    useSubmitBehavior: true,
  };

  return (
    <div
      className="form-container"
      style={{ overflow: "auto", height: height - 56, paddingBottom: 20 }}
    >
      <Toolbar>
        <Item location="before" widget="dxButton" options={backButtonOptions} />
        <Item location="center" text={"Chi tiết HardContent"} />
      </Toolbar>

      <form action="your-action" onSubmit={handleSubmit}>
        <Form colCount={2} formData={hardContent}>
          <GroupItem caption="Thông tin cơ bản">
            <TabbedItem itemType="tabbed" colCount={2} colSpan={2}>
              {tabs.map((item) => {
                return (
                  <Tab key={item.id} title={item.text} icon={item.icon}>
                    <SimpleItem
                      dataField={`name-${item.languageId}`}
                      editorType="dxTextArea"
                    >
                      <Label text={formatMessage("name")} />
                      <RequiredRule />
                    </SimpleItem>
                    <SimpleItem
                      dataField={`description-${item.languageId}`}
                      //   editorType="dxTextArea"
                      //   editorOptions={notesEditorOptions}
                    >
                      <Label text={formatMessage("description")} />
                      <CKHtmlEditor
                        value={hardContent[`description-${item.languageId}`]}
                        onInit={setEditor}
                        initHeight="250px"
                      />
                    </SimpleItem>
                  </Tab>
                );
              })}
            </TabbedItem>
          </GroupItem>

          <GroupItem itemType="group" caption="Thông tin khác">
            <GroupItem>
              <SimpleItem>
                <Label text={formatMessage("image")} />
                <FileSelectPopup
                  value={hardContent.image}
                  imgHeight={150}
                  onValueChanged={updateImage}
                />
              </SimpleItem>
            </GroupItem>

            <GroupItem>
              <SimpleItem dataField={"code"} editorType="dxTextBox">
                <Label text={formatMessage("code")} />
              </SimpleItem>
              <SimpleItem dataField={"alt"} editorType="dxTextBox">
                <Label text={formatMessage("alt")} />
              </SimpleItem>
              <SimpleItem dataField={"url"} editorType="dxTextBox">
                <Label text={formatMessage("url")} />
              </SimpleItem>
              <SimpleItem dataField={"order"} editorType="dxNumberBox">
                <Label text={formatMessage("order")} />
              </SimpleItem>
              <SimpleItem dataField={"isActive"} editorType="dxCheckBox">
                <Label text={formatMessage("isActive")} />
              </SimpleItem>
            </GroupItem>
          </GroupItem>

          <ButtonItem
            colSpan={2}
            horizontalAlignment="center"
            buttonOptions={saveButtonOptions}
          />
        </Form>
      </form>

      <hr />
      {params.hardContentId && (
        <HardContentItemsList
          hardContentId={params.hardContentId}
          accessToken={accessToken}
          languages={websiteLanguages}
          currentWebsite={currentWebsite}
          currentLanguage={currentLanguage}
        />
      )}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    accessToken: state.auth.data.token,
    currentLanguage: state.setting.currentLanguage,
    languages: state.setting.languages,
    currentWebsite: state.website.data.currentWebsite,
    websiteLanguages: state.website.data.languages,
  };
};

HardContentDetailContainer.propTypes = {
  accessToken: PropTypes.string,
  websiteLanguages: PropTypes.array,
  currentWebsite: PropTypes.string,
  currentLanguage: PropTypes.string,
};

export default connect(mapStateToProps, null)(HardContentDetailContainer);
